export const nl = {
  common: {
    dashboard: 'Dashboard',
    cancel: 'Annuleren',
    save: 'Opslaan',
    location: 'Locatie',
    type: 'Type',
    depot: 'Depot',
    date: 'Datum',
  },
  dashboard: {
    title: 'Dashboard',
    collecting: {
      title: 'Uitgifte',
      subtitle: 'Snel starten',
      buttonText: 'Nieuwe uitgifte',
    },
    returning: {
      title: 'Inname',
      subtitle: 'Snel starten',
      buttonText: 'Nieuwe inname',
    },
    transactions: {
      title: 'Transacties',
    },
  },
  userMenu: {
    account: 'Account',
    language: {
      label: 'Taal',
      dutch: 'Nederlands',
      english: 'Engels',
    },
    logout: 'Uitloggen',
    businessAssociations: 'Ketenverbanden',
    loadingBusinessAssociations: 'Ketenverbanden laden...',
    role: 'Gebruiker',
    businessAssociationSelector: {
      title: 'Ketenverband selecteren',
      open: 'Alle ketenverbanden bekijken',
      searchLabel: 'Ketenverbanden zoeken',
      searchPlaceholder: 'Zoek op naam of nummer',
      noResults: 'Geen ketenverbanden gevonden',
    },
  },
  businessAssociationBanner: {
    workingFor: 'Werkend voor:',
    ownUse: 'Eigen gebruik:',
  },
  sidebar: {
    newCollecting: 'Nieuwe uitgifte',
    newReturning: 'Nieuwe inname',
    transactions: 'Transacties',
    openingHours: 'Openingstijden',
  },
  errorFallback: {
    genericError: 'Er is een fout opgetreden',
    pageLoadError:
      'De pagina kon niet goed worden geladen. U kunt teruggaan naar het dashboard.',
    backToDashboard: 'Terug naar dashboard',
  },
  transactions: {
    deleteDialog: {
      title: 'Verwijderen bevestigen',
      heading: 'Weet je zeker dat je dit wilt verwijderen?',
      description:
        'De transactie wordt permanent verwijderd. Deze actie kan niet ongedaan worden gemaakt.',
      confirm: 'Verwijderen',
    },
    empty: {
      title: 'Geen transacties gevonden',
      description:
        "Er zijn op dit moment geen transacties met de staat '{{selectedTab}}'.",
    },
    viewAll: 'Bekijk alle transacties',
    title: 'Transacties',
    codesCount: '{{count}} codes',
    table: {
      code: 'CODE',
      stw: 'STW',
      stpl: 'STPL',
      stk: 'STK',
      total: 'Totaal',
    },
    tabs: {
      open: 'Open',
      closed: 'Gesloten',
    },
    toolbar: {
      searchPlaceholder: 'Zoeken op transactienummer',
      filterButton: 'Filter',
      exportSelect: 'Selecteer',
      select: 'Selecteer',
      cancelSelect: 'Annuleren',
      download: 'Downloaden ({{count}})',
    },
    selection: {
      selectAll: 'Selecteer alles',
      remove: 'Wis',
      selectTransaction: 'Transactie {{transactionId}} selecteren',
    },
    pdf: {
      transactionType: 'Transactietype',
      customerName: 'Klantnaam',
      customerNumber: 'Klantnummer',
      transporterName: 'Transporteur naam',
      transporterNumber: 'Transporteurnummer',
      transactionDate: 'Transactiedatum',
      createdDate: 'Aanmaakdatum',
      transactionStatus: 'Transactiestatus',
      transactionNumber: 'Transactienummer',
      item: 'Item',
      stapelwagen: 'Stapelwagen',
      stapel: 'Stapel',
      stuks: 'Stuks',
      total: 'Totaal',
      notes: 'Notities',
    },
    filters: {
      type: 'Transactie type',
      date: 'Datum',
      businessAssociation: 'Ketenverband',
      businessAssociationPlaceholder: 'Zoek ketenverbanden',
    },
  },
  transactionType: {
    UitgifteDock: 'Uitgifte Dock',
    UitgifteMobiel: 'Uitgifte Mobiel',
    UitgifteVast: 'Uitgifte Vast',
    InnameVast: 'Inname Vast',
    InnameMobiel: 'Inname Mobiel',
  },
  collecting: {
    backToOverview: 'Terug naar overzicht',
    editCollecting: 'Bewerk uitgifte',
    newCollecting: 'Nieuwe uitgifte',
    editAssociationError:
      'Je kan geen transactie bewerken van een ander ketenverband',
    loadingTransactionError:
      'Er is een fout opgetreden bij het laden van de transactie.',
    transactionNotFound: 'Transactie niet gevonden.',
    submitError:
      'Er is een fout opgetreden bij het verzenden van de transactie.',
    updatedSuccess: 'Uitgifte is bijgewerkt',
    sentSuccess: 'Uitgifte is verstuurd',
    step1: {
      heading: 'Locatie & Datum',
      locationLabel: 'Kies uw locatie',
      collectingTypeLabel: 'Hoe vindt de uitgifte plaats?',
      collectingType: 'Uitgifte type',
      packagingLocation: 'Fustlocatie: {{fixedDepotLabel}}',
      packagingLocationPlaceholder: 'Selecteer een fustlocatie',
      customerLocationPlaceholder: 'Selecteer een klantlocatie',
      unknownDepotLabel: 'Onbekende locatie',
    },
    step2: {
      heading: 'Artikelen & Aantallen',
      fillArticles: 'Vul uw artikelen in',
      addRow: 'Regel toevoegen',
      articleNumbering: 'Artikel {{rowNumber}}',
    },
    step3: {
      heading: 'Afronden',
      summary: 'Controleer uw gegevens',
      checkDetails: 'Controleer uw gegevens',
      articles: 'Artikelen',
      note: 'Notitie',
      notePlaceholder: 'Heeft u nog een opmerking?',
      submit: 'Verstuur',
      workingFor: 'Werkend voor:',
      customerLocation: 'Klantlocatie:',
      code: 'CODE',
      stw: 'STW',
      stpl: 'STPL',
      stk: 'STK',
      total: 'Totaal',
    },
    transactionTypeInformation: {
      UitgifteDock: 'Avondbestelling op een vaste locatie',
      UitgifteMobiel: 'Bezorging in uw klantbox',
      UitgifteVast: 'Afhalen op een vaste locatie',
    },
    fustcodes: {
      selectHubFirst: 'Selecteer eerst een hub',
      noneAvailable: 'Geen fustcodes beschikbaar',
      notOrderable: 'Deze fustcode kan niet besteld worden',
    },
    hubTimes: {
      nowOpenUntilInfinity: 'Nu geopend (tot infinity)',
      viewAllOpeningHours: 'Bekijk alle openingstijden',
    },
  },
  returning: {
    backToOverview: 'Terug naar overzicht',
    editReturning: 'Bewerk inname',
    newReturning: 'Nieuwe inname',
    editAssociationError:
      'Je kan geen transactie bewerken van een ander ketenverband',
    loadingTransactionError:
      'Er is een fout opgetreden bij het laden van de transactie.',
    transactionNotFound: 'Transactie niet gevonden.',
    submitError:
      'Er is een fout opgetreden bij het verzenden van de transactie.',
    updatedSuccess: 'Inname is bijgewerkt',
    sentSuccess: 'Inname is verstuurd',
    step1: {
      heading: 'Locatie & Datum',
      locationLabel: 'Kies uw locatie',
      collectingTypeLabel: 'Hoe vindt de inname plaats?',
      collectingType: 'Inname type',
      packagingLocation: 'Fustlocatie: {{fixedDepotLabel}}',
      packagingLocationPlaceholder: 'Selecteer een fustlocatie',
      customerLocationPlaceholder: 'Selecteer een klantlocatie',
      unknownDepotLabel: 'Onbekende locatie',
    },
    step2: {
      heading: 'Artikelen & Aantallen',
      fillArticles: 'Vul uw artikelen in',
      addRow: 'Regel toevoegen',
      articleNumbering: 'Artikel {{rowNumber}}',
    },
    step3: {
      heading: 'Afronden',
      summary: 'Controleer uw gegevens',
      checkDetails: 'Controleer uw gegevens',
      articles: 'Artikelen',
      note: 'Notitie',
      notePlaceholder: 'Heeft u nog een opmerking?',
      submit: 'Verstuur',
      workingFor: 'Werkend voor:',
      customerLocation: 'Klantlocatie:',
      code: 'CODE',
      stw: 'STW',
      stpl: 'STPL',
      stk: 'STK',
      total: 'Totaal',
    },
    transactionTypeInformation: {
      InnameMobiel: 'Ophalen uit uw klantbox',
      InnameVast: 'Inleveren op een vaste locatie',
    },
    fustcodes: {
      selectHubFirst: 'Selecteer eerst een hub',
      noneAvailable: 'Geen fustcodes beschikbaar',
      notOrderable: 'Deze fustcode kan niet besteld worden',
    },
    hubTimes: {
      nowOpenUntilInfinity: 'Nu geopend (tot infinity)',
      viewAllOpeningHours: 'Bekijk alle openingstijden',
    },
  },
  inventory: {
    title: 'Mijn voorraad',
    unitCount: '{{count}} stuks',
  },
  warnings: {
    spendingLimit:
      'Uw uitgifte plafond voor saldo dragende items is (bijna) bereikt. Indien het plafond bij daadwerkelijke uitgifte wordt overschreden is uitgifte niet mogelijk. Houdt hier rekening mee.',
  },
} as const
